import IconDesc from "../my-course/IconDesc";
import Button from "olive-react-myoneui/lib/Button";
import { geoMarkIcon, chatIcon, clockIcon, awardIcon, stackIcon, documents, StarIcon, shoppingBag, rssIcon, multipleSessionIcon } from "../../../constants/icons";
import EventCountTag from "../event-listing/eventCountTag";
import BundleTag from "../courses/BundleTag";
import Badge from "olive-react-myoneui/lib/Badge";
import LinkWrapper from "../../LinkWrapper";
import { fullMonths, shortMonths } from "../../../constants/timeZoneList";
import { useNavigate } from "react-router-dom";
import AddToCartButton from "../AddToCartButton";
import BuyNowButton from "../BuyNowButton";
import EnrollNowButton from "../EnrollNowButton";
import RedirectURLObject from "../../RedirectURLObject";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import { commonModuleName } from "../../../constants/config";
import IamInterestedButton from "../IamInterestedButton";
import IaminterestedModal from "../IamInterestedModal";
import { useState } from "react";

function CourseEventWithHover({ course, className = "", miscellaneous, offsetDifference, paths, currentTimeStamp }) {
  const { t } = useTranslation(commonModuleName);
  const navigate = useNavigate();
  const free = course.item_is_free == '1';
  const id   = course.item_id;
  const type = course.item_type;
  const waitingListURL = RedirectURLObject({ type: 'enroll_now', redirectTo: `/cart_react?item=${type}_${id}` })
  const self_enroll = course.item_self_enroll === undefined ? true : (course.item_self_enroll == "0" ? false : (course.item_self_enroll_date === null ? true : (new Date(course.item_self_enroll_date).getTime() >= new Date(miscellaneous.current_date).getTime())) );
  const currentCurrencySymbol = miscellaneous.current_currency.symbol;
  let imagePath = course.item_full_image;
  let defaultImage = "";
  let registration_started = true;
  let registration_ended = false;
  const [showIamInterestedModal, setShowIamInterestedModal] = useState(false);

  switch (type) {
    case 'course':
      defaultImage = paths.default_course;
    break;
    case 'bundle':
      defaultImage = paths.default_bundle;
    break;
    case 'blended':
      defaultImage = paths.default_course;
    break;
    case 'online':
      defaultImage = paths.default_course;
    break;
    case 'booking_event':
      defaultImage = paths.default_event;
      registration_started = currentTimeStamp >= new Date(course.item_reg_start_time).getTime() + offsetDifference;
      registration_ended = currentTimeStamp >  new Date(course.item_reg_end_time).getTime() + offsetDifference;
    break;
    case 'offline':
      defaultImage = paths.default_course;
    break;
    default:
      defaultImage = paths.default_course;
    break;
  }
  let single_day_event = true;
  const registration_status = course.item_enable_disable_reg === undefined ? true : course.item_enable_disable_reg == "1" && registration_started && !registration_ended;
  const subscription_status = course.item_b2b_imported === undefined ? true : course.item_b2b_imported == "0" || (course.item_b2b_imported == "1" && course.item_no_of_subscriptions > course.item_enrolled_learners_count);
  const unable_to_register_button_label = registration_status ? null : (course.item_enable_disable_reg == "1" ? (registration_started && registration_ended ? "Registration Closed" : "Coming Soon") : "View More");
  let disabledClass = self_enroll ? "" : " disabled";
  let waitingList = false;
  let soldOut = false;
  if (typeof course.item_availability_seats != "undefined" && course.item_availability_seats < 1) {
    className += "sold";
    soldOut = true;
    if (course.item_waiting_list == "1") {
      waitingList = true;
    } else {
      disabledClass = " disabled";
    }
  }
  let badge_text = "";
  let time_text = "";
  if (["booking_event"].includes(type)) {
    let start_date = new Date(new Date(course.item_start_date + " " + course.item_start_time).getTime() + offsetDifference);
    let end_date = new Date(new Date(course.item_end_date + " " + course.item_end_time).getTime() + offsetDifference);
    single_day_event = ("0" + start_date.getDate()).substr(-2) + ("0" + start_date.getMonth()).substr(-2) + start_date.getFullYear() == ("0" + end_date.getDate()).substr(-2) + ("0" + end_date.getMonth()).substr(-2) + end_date.getFullYear();
    badge_text = single_day_event ? `${("0" + start_date.getDate()).substr(-2)} ${fullMonths[start_date.getMonth()]}  ${start_date.getFullYear()}` : `${("0" + start_date.getDate()).substr(-2)} ${shortMonths[start_date.getMonth()]} - ${("0" + end_date.getDate()).substr(-2)} ${shortMonths[end_date.getMonth()]}`;
    let hour = start_date.getHours();
    let ampm = "AM";
    if (hour >= 12) {
      ampm = "PM";
      if (hour > 12) {
        hour -= 12;
      }
    }
    time_text = `${!single_day_event ? `${("0" + start_date.getDate()).substr(-2)} ${shortMonths[start_date.getMonth()]} ` : ''}${("0" + hour).substr(-2)}:${("0" + start_date.getMinutes()).substr(-2)} ${ampm} - `;
    hour = end_date.getHours();
    ampm = "AM";
    if (hour >= 12) {
      ampm = "PM";
      if (hour > 12) {
        hour -= 12;
      }
    }
    time_text += `${!single_day_event ? `${("0" + end_date.getDate()).substr(-2)} ${shortMonths[end_date.getMonth()]} ` : ''}${("0" + hour).substr(-2)}:${("0" + end_date.getMinutes()).substr(-2)} ${ampm}`;
  }

  const descCarouselCommonContent = <LinkWrapper className="text-decoration-none" isReact={true} href={"/" + course.item_slug}>
    <div className="heading-desc">
      <h1>{course.item_name}</h1>
      <p className="short-desc">{course.item_short_description}</p>
    </div>
    <div className="align-items-center gap-2 mb-3 sub-label">
      {
        (type == "course") && (
          <IconDesc
            icon={documents}
            paraDesc={course.item_tag.split(" ")[0] + " " + t('lectures')}
          />
        )
      }
      {
        (type == "bundle") && (
          <>
            <IconDesc
              icon={shoppingBag}
              paraDesc={course.item_course_count + " " + t('courses')}
            />
            <IconDesc
              icon={shoppingBag}
              paraDesc={course.item_training_courses_count + " " + t('training courses')}
            />
            <IconDesc
              icon={shoppingBag}
              paraDesc={course.item_training_events_count + " " + t('training events')}
            />
          </>
        )
      }
      {
        (["booking_event"].includes(type)) && time_text != "" && (
          <>
            <IconDesc
              icon={course.item_tag_type == "single-live" ? rssIcon : (course.item_tag_type == "multiple" ? multipleSessionIcon : geoMarkIcon)}
              paraDesc={course.item_tag}
            />
            <IconDesc
              icon={clockIcon}
              paraDesc={time_text}
            />
          </>
        )
      }
    </div>
    <div className="d-flex align-items-end justify-content-between course-price-wrapper mt-0">
      {course.item_price_label_show == 1 && (
        <>
          <div className="pricing-slot pricing-left">
          {
              (miscellaneous.show_member_price && course.member_status == "1" && course.item_is_free == "0") && (
                <span>{t(miscellaneous.current_pricing_label)}</span>
              )
            }
            {
              course.item_is_free == '0' && course.item_discount > 0 ?
                <div className="price">{currentCurrencySymbol + course.item_discount} <span>{currentCurrencySymbol + course.item_price}</span></div>
                :
                <>
                  {
                    course.item_is_free == '0' ?
                      <div className="price">{currentCurrencySymbol + course.item_price}</div>
                      :
                      <>
                        {
                          ["booking_event"].includes(type) ?
                          <>
                            {miscellaneous.event_free_label_enabled && <div className="price">{t(miscellaneous.event_free_label)}</div>}
                          </>
                          :
                          <>
                            {miscellaneous.free_label_enabled && <div className="price">{t(miscellaneous.free_label)}</div>}
                          </>
                        }
                      </>
                  }
                </>
            }
          </div>
          {miscellaneous.show_member_price && course.member_status == "1" && course.item_is_free == "0" && (
            <>
              <span className="separator-price-set"></span>
              <div className="pricing-slot pricing-right">
                <span>{t(miscellaneous.member_pricing_label)}</span>
                {course.member_price > 0 && (
                  <div className="price">{currentCurrencySymbol + course.member_price}</div>
                )}
                {
                  course.member_price <= 0 &&
                  <>
                    {
                      ["booking_event"].includes(type) ?
                        <>
                          {miscellaneous.event_free_label_enabled && <div className="price">{t(miscellaneous.event_free_label)}</div>}
                        </>
                        :
                        <>
                          {miscellaneous.free_label_enabled && <div className="price">{t(miscellaneous.free_label)}</div>}
                        </>
                    }
                  </>
                }
              </div>
            </>
          )}
        </>
      )}
    </div>

  </LinkWrapper>

const round = (args) => {
  return Math.round(args)
}
  return (
    <div className="event-block-wrapper event-hoverable course-event-wrapper course-discounted">
      <div className={`${className || ""} carousel-block p-0` + (course.item_availability_seats <= 5 && course.item_availability_seats > 0 ? " " + t('limited') : "")}>
        <LinkWrapper className="text-decoration-none" isReact={true} href={"/" + course.item_slug}>
          <div className="img-carousel">              
            <img src={imagePath} className="img-fluid" onError={({ currentTarget }) => {
              if (!currentTarget.getAttribute("errored")) {
                currentTarget.setAttribute("errored", '1');
                currentTarget.src = defaultImage;
              }
            }}/>
            <span class="icon-hotsale">
              <img src="https://d2cl07xv2ii8xi.cloudfront.net/uploads/default/catalog/icon-hot-sale.png" alt="Hot sale icon" />
            </span>
            {
              (["booking_event"].includes(type)) && (
                <Badge className="badge blue badge-round">{badge_text}</Badge>
              )
            }
          </div>
        </LinkWrapper>
        <div className="desc-carousel">
          {descCarouselCommonContent}
          <div className="rating-cart-wrapper d-flex align-items-center justify-content-between pt-3">
            <div className="rating-digits d-flex align-items-center gap-2">
              {
                
                (["course", "bundle"].includes(type) && course.item_ratting > 0 && course.c_rating_enabled > 0) && (
                  <>
                    <span>{course.item_ratting}</span>
                    <StarIcon
                      className="cursor-pointer"
                      icon="star"
                    />
                  </>
                )
              }
              {
                (["booking_event", "blended", "online", "offline"].includes(type)) && course.item_certified && (
                  <>
                    {awardIcon}
                    <span>{t('certified')}</span>
                  </>
                )
              }
            </div>
            {
              ["course", "bundle"].includes(type) &&
              <>
                {
                  self_enroll && subscription_status ?
                  <>
                    {
                      !free &&
                      <>
                        {
                          miscellaneous.shopping_cart ? 
                              <AddToCartButton className={disabledClass} fromCourseList={true} itemId={id} itemType={type} />
                            :
                            <>
                              {
                                miscellaneous.buy_now_button_enabled &&
                                <BuyNowButton variant="outline" className={disabledClass} itemId={id} itemType={type}/>
                              }
                            </>
                        }
                      </>
                    }
                    {
                      free && <EnrollNowButton variant="outline" className={disabledClass} itemType={type} itemId={id} />
                    }
                  </>
                  :
                  <Button
                      variant="outline"
                      className=""
                      size="md"
                      onClick={() => navigate("/" + course.item_slug)}
                  >
                    {t('view_more')}
                  </Button>
                }
              </>
            }
            {
              ["blended", "online", "offline"].includes(type) &&
              <Button
                variant="outline"
                className=""
                size="md"
                onClick={() => navigate("/" + course.item_slug)}
              >
                {t('view_more')}
              </Button>
            }
            {
              ["booking_event"].includes(type) &&
              <>
                {
                  soldOut && !waitingList ?
                  <Button
                    variant="outline"
                    className="disabled btn-sold-out"
                    size="md"
                  >
                    {t('sold_out')}
                  </Button>
                  :
                  <>
                    {
                      registration_status ?
                      <>
                        {
                          waitingList ?
                          <Button
                            variant="outline"
                            className={disabledClass}
                            size="md"
                            onClick={() => {waitingListURL.isReact ? navigate(waitingListURL.url) : window.location.href = waitingListURL.url}}
                          >
                            {t('add_to_waiting_list')}
                          </Button>
                          :
                          <>
                            {
                              !free &&
                              <>
                                {
                                  miscellaneous.shopping_cart && course.item_is_approval_required != "1" ? 
                                  <AddToCartButton className={disabledClass} fromCourseList={true} itemId={id} itemType={type} />
                                  :
                                  <>
                                    {
                                     course.item_is_approval_required && course.item_is_approval_required == "1" ?
                                     <>
                                        <IamInterestedButton item={course} variant="outline" className={disabledClass} itemId={id} />

                                     </>
                                     :
                                     <>
                                     {
                                       miscellaneous.event_buy_now_button_enabled &&
                                       <BuyNowButton variant="outline" className={disabledClass} itemId={id} itemType={type}/>
                                     }
                                     </>
                                    }
                                  </>
                                }
                              </>
                            }
                            {
                              free && course.item_is_approval_required != "1" && course.item_is_approval_required != 1 &&  <EnrollNowButton variant="outline" className={disabledClass} itemType={type} itemId={id} />
                            }
                            {
                              free && course.item_is_approval_required == "1" && course.item_is_approval_required == 1 &&   <IamInterestedButton item={course} variant="outline" className={disabledClass} itemId={id} />

                            }
                          </>
                        }
                      </>
                      :
                      <Button
                        variant="outline"
                        className={unable_to_register_button_label === "View More" ? "" : "disabled " + (unable_to_register_button_label === "Registration Closed" ? "btn-reg-closed" : "btn-coming-soon")}
                        size="md"
                        onClick={() => unable_to_register_button_label == "View More" ? navigate("/" + course.item_slug) : null}
                      >
                        {t(unable_to_register_button_label)}
                      </Button>
                    }
                  </>
                }
              </>
            }
          </div>
        </div>
        {
          (type == "bundle") && (
            <BundleTag className="" tagIcon={stackIcon} bundleCount={`${course.item_course_count + course.item_training_courses_count + course.item_training_events_count} in 1`} />
          )
        }
        {/* Hover Overlay */}
        <div className="hover-overlay">
          <div className={`${className || ""} carousel-block p-0`}>
            <div className="desc-carousel">
              {descCarouselCommonContent}
              <div className="rating-cart-wrapper">
                {
                  ["course", "bundle", "booking_event"].includes(type) && self_enroll && registration_status && subscription_status && (!soldOut || waitingList) ?
                  <>
                    {
                      waitingList ?
                      <Button
                        variant="outline"
                        className={"w-100 mb-3" + disabledClass}
                        size="md"
                        onClick={() => {waitingListURL.isReact ? navigate(waitingListURL.url) : window.location.href = waitingListURL.url}}
                      >
                        {t('add_to_waiting_list')}
                      </Button>
                      :
                      <>
                      { course?.item_is_approval_required == "1" && <IamInterestedButton item={course} variant="outline"  itemId={course?.item_id} />}

                        {
                          !free && miscellaneous.shopping_cart && course?.item_is_approval_required != "1" &&
                              <AddToCartButton className={"w-100 mb-3" + disabledClass + (free || !miscellaneous.shopping_cart || ["blended", "online", "offline"].includes(type) ? " disabled" : "")} fromCourseList={true} itemId={id} itemType={type} />
                        }
                        {
                          !free && miscellaneous.buy_now_button_enabled && course?.item_is_approval_required != "1" &&
                          <BuyNowButton className={"w-100 mb-3" + disabledClass + (["blended", "online", "offline"].includes(type) ? " disabled" : "")} itemId={id} itemType={type}/>
                        }
                        {
                          free && course?.item_is_approval_required != "1" && <EnrollNowButton className={"w-100 mb-3" + disabledClass} itemType={type} itemId={id} />
                        }
                      </>
                    }
                  </>
                  :
                  <>
                    {
                      type != "booking_event" || !self_enroll ?
                      <Button
                          variant="outline"
                          className="w-100 mb-3"
                          size="md"
                          onClick={() => navigate("/" + course.item_slug)}
                      >
                        {t('view_more')}
                      </Button>
                      :
                      <>
                        {
                          !registration_status ?
                          <Button
                            variant="outline"
                            className={"w-100 mb-3 disabled " + (unable_to_register_button_label === "Registration Closed" ? "btn-reg-closed" : "btn-coming-soon")}
                            size="md"
                            // onClick={() => navigate("/" + course.item_slug)}
                          >
                            {t(unable_to_register_button_label)}
                          </Button>
                          :
                          soldOut &&
                          <Button
                            variant="outline"
                            className="w-100 mb-3 disabled btn-sold-out"
                            size="md"
                          >
                            {t('sold_out')}
                          </Button>
                        }
                      </>
                    }
                  </>
                }
                {
                  miscellaneous.enquiry_button_enabled && ["course", "bundle", "booking_event"].includes(type) && course.item_enquiry_needed == "1" &&
                  <Button
                    variant="outline"
                    className={"w-100 border-0 mb-0" + (miscellaneous.enquiry_button_enabled && course.item_enquiry_needed == "1" ? "" : " disabled")}
                    size="md"
                    onClick={() => navigate(`/enquiry?name=${encodeURIComponent(course.item_name)}&type=${type == "booking_event" ? "event" : encodeURIComponent(type)}`)}
                  >
                    {chatIcon} {t(miscellaneous.enquiry_button)}
                  </Button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      {
        (type == "booking_event") && course.item_enable_disable_reg == "1" &&
        <>
          {
            course.item_show_seat_availability == "1" ?
            <EventCountTag eventCountLabel={soldOut ? t('sold_out') : (course.item_availability_seats + " " + t('seats_left'))} />
            :
            <>
              <EventCountTag eventCountLabel={soldOut ? t('sold_out') : (course.item_availability_seats <= 5 ? t('limited_seats') : "")} />
            </>
          }
        </>
      }
    </div>
  );
}

export default CourseEventWithHover;
